import { Box, Button, Typography } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { PluginKey } from "resource-planner-model";
import { ReactElement } from "react";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { tokens } from "../app/theme";
import { PLUGIN_CATALOG, pluginEntry } from "./pluginCatalog";
import { HarvestPluginForm } from "./HarvestPluginForm";
import { JiraPluginForm } from "./JiraPluginForm";
import { MicrosoftShiftsPluginForm } from "./MicrosoftShiftsPluginForm";
import { MicrosoftTenantPluginForm } from "./MicrosoftTenantPluginForm";

const KNOWN_KEYS = new Set(PLUGIN_CATALOG.map((entry) => entry.key));

const PLUGIN_FORMS: Record<PluginKey, () => ReactElement> = {
  jira: JiraPluginForm,
  harvest: HarvestPluginForm,
  microsoftShifts: MicrosoftShiftsPluginForm,
  microsoftTenant: MicrosoftTenantPluginForm,
};

export function PluginSettingsPage() {
  const history = useHistory();
  const { pluginKey } = useParams<{ pluginKey: string }>();

  if (!KNOWN_KEYS.has(pluginKey as PluginKey)) {
    return <Redirect to="/administration/plugins" />;
  }

  const key = pluginKey as PluginKey;
  const entry = pluginEntry(key);
  const Form = PLUGIN_FORMS[key];

  return (
    <Box maxWidth={720}>
      <Button
        size="small"
        startIcon={<ArrowBackIcon />}
        onClick={() => history.push("/administration/plugins")}
      >
        Plugins
      </Button>
      <Typography variant="h4" style={{ marginTop: 8 }}>
        {entry.label}
      </Typography>
      <Typography variant="body2" style={{ color: tokens.fg2, marginTop: 4 }}>
        {entry.description}
      </Typography>
      <Form />
    </Box>
  );
}
